export default __webpack_public_path__ + "static/btn-dl-ja-m@2x-137b582e8ff5b2ea887cc2907968c268.png";